module.exports = __webpack_public_path__ + "static/img/QX.4bc8746.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/QX.png
// module id = iCXK
// module chunks = 34